import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  GlobalStyles,
  Grid,
  List,
  ListItem,
  Paper,
  Switch,
  Typography,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import ReactGA from "react-ga";
import { AppContext } from "../context";
import { useWindowDimensions } from "../hooks/useWindowDimensions";
export const BaladaProtect = () => {
  const { plan, getThemeAndPlans, logo, accountTheme, backgroundImage, theme } =
    useContext<any>(AppContext);
  const { width } = useWindowDimensions();
  const background = theme ? theme.palette.background.default : "#fff";
  const [recurrency, setRecurrency] = useState(true);

  const id = "6377d07a0ad87e81596c9766";

  useEffect(() => {
    if (!accountTheme) {
      getThemeAndSeller();
    }
    console.log(id);
    ReactGA.initialize("GTM-W5LD9TN");
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  const handleClick1 = () => {
    window.location.replace(
      "https://checkout-dev.ofertadigital.in/ewq/?id=637538f021478843123973bd"
    );
  };

  const handleSwitch = (e: any) => {
    console.log(e.target.checked);
    setRecurrency(e.target.checked);
  };
  const handleClick2 = () => {
    window.location.replace(
      "https://checkout-dev.ofertadigital.in/ewq/?id=6377d07a0ad87e81596c9766"
    );
  };
  const getThemeAndSeller = async () => {
    await getThemeAndPlans(id);
  };

  useEffect(() => {
    if (!accountTheme) {
      getThemeAndSeller();
    }
  }, []);

  return (
    <>
      {plan && (
        <Box
          sx={{
            maxHeight: "100vh",
            width: "80vw",
            maxWidth: "1500px",
            margin: "auto",
            paddingTop: "10px",
          }}
        >
          <GlobalStyles
            styles={{
              body: {
                backgroundColor: `${background}`,
                padding: "5px",
                maxHeight: "100vh",
              },
            }}
          />
          <Paper
            sx={{
              my: "auto",
              maxHeight: 650,
              backgroundColor: "background.default",
              boxShadow: 0,
            }}
          >
            <Grid container>
              <Grid
                item
                xl={8}
                md={8}
                sm={12}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  mb: width > 400 ? 0 : 2,
                }}
              >
                <Box
                  sx={{
                    pl: 4,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    mb: width > 400 ? 1 : 2,
                  }}
                >
                  <Box>
                    <img src={logo} alt="" style={{ width: "110px" }} />
                  </Box>
                  <Box>
                    <Typography
                      sx={{
                        color: "primary.main",
                        fontSize: "1.8rem",
                        fontWeight: "bold",
                      }}
                    >
                      Selecione seu plano
                    </Typography>
                    <Typography
                      sx={{ color: "primary.main", fontSize: "1.1rem" }}
                    >
                      Chegou a hora de selecionar a melhor opção para você
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "start",
                    alignItems: "center",
                    maxWidth: "600px",
                    mt: 2,
                  }}
                >
                  <Card
                    sx={{
                      border: 1,
                      maxWidth: 240,
                      borderColor: "primary.main",
                    }}
                  >
                    <CardContent sx={{ mt: 1 }}>
                      <Typography
                        sx={{ fontSize: "1rem" }}
                        color="primary.main"
                        gutterBottom
                      >
                        Balada Protect
                      </Typography>

                      {!recurrency && (
                        <Typography
                          color="secondary.main"
                          variant="h5"
                          component="div"
                        >
                          R$ 19,90
                        </Typography>
                      )}
                      {recurrency && (
                        <Typography
                          color="secondary.main"
                          variant="h5"
                          component="div"
                        >
                          R$ 19,90<span style={{ fontSize: "12px" }}>/mês</span>
                        </Typography>
                      )}
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "start",
                        }}
                      >
                        <Box sx={{ width: "120px" }}>
                          {!recurrency && (
                            <Typography
                              sx={{ mb: 1, fontSize: "0.8rem" }}
                              color="primary.main"
                            >
                              Cobrança única com cobertura de 30 dias
                            </Typography>
                          )}
                          {recurrency && (
                            <Typography
                              sx={{ mb: 1, fontSize: "0.8rem" }}
                              color="primary.main"
                            >
                              Cobrança recorrente mensal
                            </Typography>
                          )}
                        </Box>
                        <Switch
                          defaultChecked
                          onChange={handleSwitch}
                          checked={recurrency}
                          size="small"
                        />
                      </Box>

                      <List
                        sx={{
                          listStyleType: "disc",

                          pl: 2,
                          color: "secondary.main",
                          fontSize: "0.9rem",
                          "& .MuiListItem-root": {
                            display: "list-item",
                          },
                        }}
                        dense={true}
                      >
                        <ListItem sx={{}} disablePadding>
                          <Typography
                            sx={{ fontSize: "0.9rem" }}
                            color="secondary.main"
                          >
                            Despesas Médicas Hospitalares e Odontológicas
                          </Typography>
                        </ListItem>

                        <ListItem disablePadding>
                          <Typography
                            sx={{ fontSize: "0.9rem" }}
                            color="secondary.main"
                          >
                            Telemedicina 24 horas
                          </Typography>
                        </ListItem>

                        <ListItem disablePadding>
                          <Typography
                            sx={{ fontSize: "0.9rem" }}
                            color="secondary.main"
                          >
                            Sorteio Mensal
                          </Typography>
                          <ListItem disablePadding>
                            <Typography
                              sx={{ fontSize: "0.9rem" }}
                              color="secondary.main"
                            >
                              Morte Acidental Indenização: R$ 15 mil.
                            </Typography>
                          </ListItem>

                          <ListItem disablePadding>
                            <Typography
                              sx={{ fontSize: "0.9rem" }}
                              color="secondary.main"
                            >
                              Assistência Funeral
                            </Typography>
                          </ListItem>
                        </ListItem>
                      </List>
                    </CardContent>
                    <CardActions sx={{ justifyContent: "center", mb: 2 }}>
                      <Button
                        onClick={recurrency ? handleClick2 : handleClick1}
                        variant="contained"
                        size="small"
                      >
                        Comprar
                      </Button>
                    </CardActions>
                  </Card>
                </Box>
              </Grid>
              {width > 1000 && (
                <Grid item>
                  <Box
                    sx={{
                      maxHeight: "100%",
                      width: "100%",
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    <img src={backgroundImage} width="350px" alt="" />
                  </Box>
                </Grid>
              )}
            </Grid>
          </Paper>
        </Box>
      )}
    </>
  );
};
